import * as actionTypes from '../types/responsiblePerson';

export function getResponsiblePersonsOnStock(payload) {
  return {
    type: actionTypes.GET_RESPONSIBLE_PERSONS_ON_STOCK,
    payload
  };
}

export function getResponsiblePersonsOnStockSuccess(payload) {
  return {
    type: actionTypes.GET_RESPONSIBLE_PERSONS_ON_STOCK_SUCCESS,
    payload
  };
}

export function getResponsiblePersonsOnStockFail(payload) {
  return {
    type: actionTypes.GET_RESPONSIBLE_PERSONS_ON_STOCK_FAIL,
    payload
  };
}

export function addResponsiblePersonOnStock(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_ON_STOCK,
    payload
  };
}
export function addResponsiblePersonOnStockSuccess(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS,
    payload
  };
}
export function addResponsiblePersonOnStockFail(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_ON_STOCK_FAIL,
    payload
  };
}

export function modalResponsiblePersonsOnStockOpen(payload) {
  return {
    type: actionTypes.MODAL_RESPONSIBLE_PERSONS_ON_STOCK_OPEN,
    payload
  };
}
export function modalResponsiblePersonsOnStockClose(payload) {
  return {
    type: actionTypes.MODAL_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE,
    payload
  };
}

export function modalEditResponsiblePersonsOnStockOpen(payload) {
  return {
    type: actionTypes.MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_OPEN,
    payload
  };
}
export function modalEditResponsiblePersonsOnStockClose(payload) {
  return {
    type: actionTypes.MODAL_EDIT_RESPONSIBLE_PERSONS_ON_STOCK_CLOSE,
    payload
  };
}

export function delResponsiblePersonOnStock(payload) {
  return {
    type: actionTypes.DEL_RESPONSIBLE_PERSON_ON_STOCK,
    payload
  };
}
export function delResponsiblePersonOnStockSuccess(payload) {
  return {
    type: actionTypes.DEL_RESPONSIBLE_PERSON_ON_STOCK_SUCCESS,
    payload
  };
}
export function delResponsiblePersonOnStockFail(payload) {
  return {
    type: actionTypes.DEL_RESPONSIBLE_PERSON_ON_STOCK_FAIL,
    payload
  };
}

export function getListResponsiblePersons(payload) {
  return {
    type: actionTypes.GET_LIST_RESPONSIBLE_PERSONS,
    payload
  };
}
export function getListResponsiblePersonsSuccess(payload) {
  return {
    type: actionTypes.GET_LIST_RESPONSIBLE_PERSONS_SUCCESS,
    payload
  };
}
export function getListResponsiblePersonsFail(payload) {
  return {
    type: actionTypes.GET_LIST_RESPONSIBLE_PERSONS_FAIL,
    payload
  };
}

export function addResponsiblePerson(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON,
    payload
  };
}
export function addResponsiblePersonSuccess(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_SUCCESS,
    payload
  };
}
export function addResponsiblePersonFail(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_FAIL,
    payload
  };
}

export function delResponsiblePerson(payload) {
  return {
    type: actionTypes.DEL_RESPONSIBLE_PERSON,
    payload
  };
}
export function delResponsiblePersonSuccess(payload) {
  return {
    type: actionTypes.DEL_RESPONSIBLE_PERSON_SUCCESS,
    payload
  };
}
export function delResponsiblePersonFail(payload) {
  return {
    type: actionTypes.DEL_RESPONSIBLE_PERSON_FAIL,
    payload
  };
}
